<template>
  <div>
    <b-button
      v-b-toggle.sidebar-Notification
      style="background-color: transparent !important; border: none !important"
    >
      <feather-icon
        :badge="count.count_unread_notifications"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </b-button>

    <b-sidebar
      class=" "
      id="sidebar-Notification"
      bg-variant="dark"
      text-variant="light"
      width="400px"
      right
      backdrop 
    >
      <template #header="{ hide }">
        <div class="dropdown-header d-flex p-1 align-items-center">
          <feather-icon
            class="mr-50"
            icon="BellIcon"
            size="22"
            style="color: #fbad25"
          />
          <h4 class="notification-title mb-0 mr-1">Notifications</h4>
          <span>
            <b-badge
              pill
              variant="light-primary"
              v-if="count.count_unread_notifications"
            >
              {{ count.count_unread_notifications }} New
            </b-badge>
          </span>

          <span class="ml-1">
            <b-button class="bg-primary p-50" block @click="readAll"
              >Read all
            </b-button>
          </span>

          <span @click="hide" class="close">
            <feather-icon icon="XIcon" size="22"
          /></span>
        </div>
      </template>

      <div class="px-1">
        <div v-if="loading">
          <b-skeleton
            v-for="i in 10"
            :key="i"
            height="40px"
            width="350px"
            class="my-1"
          />
        </div>
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="scrollable-container media-list scroll-area"
          style="max-height: 85vh"
          tagname="div"
          ref="scroll"
          @ps-scroll-y="onScroll"
          v-else-if="notifications.length"
        >
          <div
            v-for="(notification, index) in notifications"
            :key="index"
            class="bg-dark"
            style="color: gray"
          >
            <b-media
              :class="[
                notification.read_at ? ' ' : '',
                'align-items-center p-1   ',
              ]"
            >
              <template #aside>
                <b-avatar
                  size="32"
                  :variant="notificationObject(notification).iconColor"
                  rounded
                >
                  <feather-icon :icon="notificationObject(notification).icon" />
                </b-avatar>
              </template>
              <div>
                <p
                  class="media-heading mb-0 d-flex align-items-center justify-content-between"
                >
                  <span class="font-weight-normal"
                    >{{ notificationObject(notification).title }}
                  </span>
                  <small class="font-weight-bolder">{{
                    notificationObject(notification).created_at
                  }}</small>
                </p>
                <small class="notification-text">{{
                  notification && notification.data && notification.data.message
                    ? notification.data.message
                    : ""
                }}</small>
              </div>
              <div
                class="d-flex align-items-center justify-content-end"
                v-if="!notification.read_at"
              >
                <b-button
                  variant="primary"
                  size="sm"
                  @click="read(notification.id)"
                >
                  read
                </b-button>
              </div>
            </b-media>
          </div>
        </vue-perfect-scrollbar>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar,
  BImg,
  BButton,
  VBToggle,
  BLink,
  BSkeleton,
  BMedia,
  BAvatar,
  BBadge,
} from "bootstrap-vue";

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BSidebar,
    BMedia,
    BAvatar,
    BBadge,
    BImg,
    BButton,
    BLink,
    BSkeleton,
    VuePerfectScrollbar,
  },
  directives: {
    "b-toggle": VBToggle,
    Ripple,
  },
  data() {
    return {
      notifications: [],
      loading: false,
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      count: {},
      interval: "",
    };
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  methods: {
    onScroll(e) {
      let rail = document.querySelector(".ps__rail-y");
      let scroll = this.$refs.scroll.$el;
      if (
        scroll.scrollHeight.toFixed(0) - rail.scrollHeight.toFixed(0) ==
          scroll.scrollTop.toFixed(0) &&
        this.pagination.total_pages > this.pagination.current_page
      ) {
        this.getNotifications(this.pagination.current_page + 1);
      }
    },
    notificationObject(notification) {
      return notification.data.type === "CHARGE"
        ? {
            title: "Charge",
            icon: "ArrowDownCircleIcon",
            iconColor: "success",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "WITHDRAW"
        ? {
            title: "Widthraw",
            icon: "ArrowUpCircleIcon",
            iconColor: "danger",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "BUY_PLAN"
        ? {
            title: "Buy plan",
            icon: "FlagIcon",
            iconColor: "info",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "COMPETITION_START_PARTNER" ||
          notification.data.type === "COMPETITION_START_PARTICIPANT"
        ? {
            title: "Competition start",
            icon: "CheckIcon",
            iconColor: "warning",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "COMPETITION_END_PARTNER" ||
          notification.data.type === "COMPETITION_END_PARTICIPANT"
        ? {
            title: "Competition end",
            icon: "XIcon",
            iconColor: "danger",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "WELCOME_COMPETITION"
        ? {
            title: "Welcome",
            icon: "CoffeeIcon",
            iconColor: "info",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "COMPLETE_COMEPTITION"
        ? {
            title: "Complete competition",
            icon: "AwardIcon",
            iconColor: "success",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "COMEPTITION_BUY"
        ? {
            title: "Competition buy",
            icon: "CheckIcon",
            iconColor: "success",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "PAID_WINNER_COMPETITION_PARTNER" ||
          notification.data.type === "PAID_WINNER_COMPETITION_PARTICIPANT"
        ? {
            title: "paid winner competition",
            icon: "DollarSignIcon",
            iconColor: "success",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "PROTEST_START"
        ? {
            title: "protest start",
            icon: "StartIcon",
            iconColor: "danger",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "WINNER_USER_COMPETITION"
        ? {
            title: "winner",
            icon: "UserIcon",
            iconColor: "primary",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "STORE_PARTNER"
        ? {
            title: "partner join",
            icon: "UserIcon",
            iconColor: "success",
            created_at: this.toLocal(notification.created_at),
          }
        : { icon: "", iconColor: "" };
    },
    async getNotifications(page) {
      try {
        const params = {
          per_page: 20,
          page: page || 1,
        };
        const { data } = await this.$http.get("/panel/notifications", {
          params,
        });
        if (page) {
          this.notifications.push(...data.data);
        } else {
          this.notifications = data.data;
        }
        this.pagination = data.meta.pagination;
      } catch (error) {}
    },
    async getCount() {
      try {
        const { data } = await this.$http.get("/panel/notifications/count");
        this.count = data;
      } catch (error) {}
    },
    async read(id) {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          `/panel/notifications/${id}?_method=patch`
        );
        this.notifications = [];
        await this.getNotifications();
        await this.getCount();
      } catch (error) {}
      this.loading = false;
    },
    async readAll() {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          `/panel/notifications/read-all?_method=patch`
        );
      } catch (error) {}
      this.notifications = [];
      await this.getNotifications();
      await this.getCount();
      this.loading = false;
    },
  },
  async created() {
    if (Object.keys(this.userData).length) {
      this.loading = true;
      await this.getNotifications();
      await this.getCount();
      this.loading = false;
      this.interval = setInterval(() => {
        this.getNotifications();
        this.getCount();
      }, 60000);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style scoped>
.b-sidebar.b-sidebar-right > .b-sidebar-header .close {
  position: absolute !important;
  right: 20px !important;
  top: 20px !important;
  color: #fa4b68 !important;
  background-color: #fa4b6838 !important;
  padding: 5px;
  border-radius: 6px;
  cursor: pointer;
}
</style>
